(function() {
    if (document.querySelectorAll('.secao-4d').length % 2 != 0 && !matchMedia('(max-width: 641px)').matches) {
        document.querySelector('.blocos-4d-ss').innerHTML =
            `
            .secao-4d:nth-last-of-type(2n) .secao-4d-inner:first-child {
                border-right: none;
                border-left: 2px solid #E07A8C;
            }
    
            .secao-4d-inner:first-child {
                border-left: none;
                border-right: 2px solid #E07A8C;
            }
    
            `;
    }

    if (matchMedia('(max-width: 641px)').matches) {
        // $('.packages').slick({
        //     infinite: false,
        //     slidesToShow: 3,
        //     slidesToScroll: 3
        // });
     
    }

    function iframeLoaded() {

        if ($('.package').length) {
            const blockButtons = Array.from(document.querySelectorAll('.package'));
            const iframeButtons = document.querySelector('iframe[title="widget_xcomponent"]').contentWindow.document.querySelectorAll('.sc-jrAFXE');

            blockButtons.forEach((k, i) => {
                k.onclick = () => {
                    blockButtons.forEach(j => j.classList.remove('package-selected'));
                    k.classList.add('package-selected');
                    iframeButtons[i].click();
                };
            });
            blockButtons[0].click();
            iframeButtons.forEach((k, i) => {
                k.onclick = function() {
                    blockButtons.forEach(j => j.classList.remove('package-selected'));
                    blockButtons[i].classList.add('package-selected');
                }
            });
        }

    }

    let selectedProducts = [];

    async function iframeButtonSend() {

        let cartItems = {
            'items': []
        };

        selectedProducts.forEach(k => {
            let obj = {};
            obj['id'] = k;
            obj['quantity'] = 1;
            cartItems['items'].push(obj);
        });

        $.ajax({
            url: location.origin + '/cart/add.js',
            type: 'POST',
            data: JSON.stringify({
                items: cartItems['items']
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            error: function(e) {
                // Error handling code
            }
        });

    }

    function iframeButtonListener() {
        const iframeInnerButtons = document.querySelector('iframe[title="widget_xcomponent"]').contentDocument.body
            .querySelectorAll('button');
        iframeInnerButtons[iframeInnerButtons.length - 1]
            .addEventListener('click', iframeButtonSend);
    }

    function callback(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                setTimeout(iframeButtonListener, 500);
                break;
            }
        }
    }


    const observer = new MutationObserver(callback);

    const checkIframe = setInterval(_ => {
        if (document.querySelector('.widget-loading-indicator').style.display == 'none') {
            setTimeout(() => {
                iframeLoaded();
            }, 1000);
            setTimeout(_ => {
                const elementoMutavel = document.querySelector('iframe[title="widget_xcomponent"]').contentWindow.document.querySelector('.relative.text-center');
                observer.observe(elementoMutavel, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }, 1000);
            setTimeout(iframeButtonListener, 1000);
            clearInterval(checkIframe);
        }
    }, 500);

    //script that converts the usual youtube URL to the embed version
    document.querySelectorAll('.ytIframe').forEach(k => {
        const urlAntiga = k.getAttribute('src');
        const videoEmbedUrl = 'https://www.youtube.com/embed/';
        let urlCorrigida;
        if (/youtu.be/.test(urlAntiga)) {
            urlCorrigida = videoEmbedUrl + urlAntiga.match(/be\/(.*)/)[0].replace(/be\//, '').replace(/&(.*)/, '');
        } else if (/youtube.com/.test(urlAntiga)) {
            urlCorrigida = videoEmbedUrl + urlAntiga.match(/v=(.*)/)[0].replace(/v=/, '').replace(/&(.*)/, '');
        }

        k.setAttribute('src', urlCorrigida);
    });
    //script that checks if the current block has more than 200 characters. And if that's the case,
    //it adds the "read more" button
    let readMoreBtsExpanded = [];
    let lastScrollPos;
    document.querySelectorAll('.read-more-btn').forEach((k, i) => {
        readMoreBtsExpanded[i] = false;
        k.onclick = () => {
            const expandir = () => {
                k.innerText = 'Read Less';
                k.parentElement.previousElementSibling.style.maxHeight = '';
                k.nextElementSibling.style.display = 'none';
                k.classList.remove('max-450');
                lastScrollPos = document.documentElement.scrollTop;
                readMoreBtsExpanded[i] = true;
            };
            const retrair = () => {
                k.innerText = 'Read More';
                k.parentElement.previousElementSibling.style.maxHeight = '300px';
                k.nextElementSibling.style.display = 'block';
                k.classList.add('max-450');
                readMoreBtsExpanded[i] = false;
                scrollTo(0, lastScrollPos);
            };
            readMoreBtsExpanded[i] ? retrair() : expandir();
        }
    });

    document.querySelectorAll('.secao-4d-inner-content').forEach(k => {
        if (k.innerText.length >= 600) {
            k.parentElement.querySelector('.read-more').style.display = 'flex';
            k.style.maxHeight = '300px';
            k.closest('.secao-4d').classList.add('max-450');
        }
    });

    let adicionaisFiltrados = [];

    document.querySelector('.extraPackageSelector').onclick = () => {
        document.querySelector('.c4d-select-extra').style.display = 'flex';
    };

    function createMiniSelected(title, id) {
        const newDiv = document.createElement('div');
        newDiv.classList.add('mini-selected-inner');
        newDiv.setAttribute('productid', id.toString());
        newDiv.innerHTML = `<span>${title}</span><button>X</button>`;
        newDiv.lastChild.onclick = () => {
            removeMiniSelected(newDiv);
            const el2 = document.querySelector(`.c4d-extra-options[productid="${id}"]`).children[0];
            el2.parentElement.setAttribute('selected', '0');
            el2.classList.remove('extra-selected');
        };
        document.querySelector('.mini-selected-products').append(newDiv);
    }

    function removeMiniSelected(el) {
        const elNum = parseInt(el.getAttribute('productid'));
        selectedProducts = selectedProducts.filter(i => (i !== elNum));
        el.remove();
    }

    function extraSelect() {
        const el = this;
        const selectEl = () => {
            el.setAttribute('selected', '1');
            el.children[0].classList.add('extra-selected');
            const elNum = parseInt(el.getAttribute('productid'));
            selectedProducts.push(elNum);
            createMiniSelected(el.children[0].children[0].innerText, elNum);
        };
        const unSelectEl = () => {
            el.setAttribute('selected', '0');
            el.children[0].classList.remove('extra-selected');
            const elNum = parseInt(el.getAttribute('productid'));
            selectedProducts = selectedProducts.filter(i => (i !== elNum));
            removeMiniSelected(document.querySelector(`.mini-selected-products .mini-selected-inner[productid="${elNum}"]`));
        };

        !parseInt(this.getAttribute('selected')) ? selectEl() : unSelectEl();
    }

    (async function() {
        const correctPrice = val => {
            const str = `${val}`;
            const reverse = string => (string.split('').reverse().join().replaceAll(',', ''));
            let newStr = reverse(str).substr(0, 2) + '.' + reverse(str).substr(2);

            return '$' + reverse(newStr);
        };
        for (let prod of produtosAdicionais) {
            if (!prod.path) {
                continue;
            }
            let available;
            try {
                await $.ajax({
                    url: location.origin + prod.path + '.js',
                    type: 'GET',
                    dataType: 'json',
                    success: function(data) {
                        available = data.available;
                    }
                });
            } catch (error) {
                alert(error.message);
            }
        
            if (available) {
                try {
                    await $.ajax({
                        url: location.origin + prod.path + '.js',
                        type: 'GET',
                        dataType: 'json',
                        success: function(data) {
                            prod.data = data;
                            adicionaisFiltrados.push(prod);
                            const newDiv = $('<div>').addClass('c4d-extra-options page__content');
                            const divSpan1 = $('<span>').text(prod.data.title);
                            const divSpan2 = $('<span>').text(correctPrice(prod.data.price));
                            const newDiv2 = $('<div>').appendTo(newDiv);
                            newDiv2.append(divSpan1);
                            newDiv2.append(divSpan2);
                            newDiv.click(extraSelect);
                            newDiv.attr('selected', '0');
                            newDiv.attr('productid', prod.data.variants[0].id.toString());
                            $('.c4d-select-extra section').append(newDiv);
                        }
                    });
                } catch (error) {
                    alert(error.message);
                }
            }
        }
        
        const divBotaoAdd = document.createElement('div');
        const botaoAdd = document.createElement('button');
        botaoAdd.innerText = 'Add products';
        divBotaoAdd.append(botaoAdd);
        divBotaoAdd.classList.add('div-botao-add');
        document.querySelector('.c4d-select-extra section').append(divBotaoAdd);

        function fecharSelect() {
            this.closest('.c4d-select-extra').style.display = 'none';
        }

        document.querySelectorAll('.c4d-select-extra button').forEach(k => {
            k.onclick = fecharSelect;
        });

        document.querySelector('.c4d-select-extra').addEventListener('click', function(e) {
            this.style.display = 'none';
        });

        document.querySelector('.c4d-select-extra section').addEventListener('click', e => {
            e.stopPropagation();
        });
    })()
    .catch(e => {
        console.log(e);
    });
})();